/* ============================================================
   LOLOI THEME — GLOBAL JS
   ============================================================ */

(function () {
  'use strict';

  // ── Header scroll behaviour (smart sticky + transparent) ────
  function initHeader() {
    var header = document.querySelector('.site-header');
    if (!header) return;

    var isTransparent = header.classList.contains('is-transparent');
    var lastScroll    = 0;
    var ticking       = false;

    function update() {
      var current = window.scrollY;

      // While the mobile menu, cart drawer, or search overlay is open
      // (they all lock body scroll), keep the header bar visible and
      // don't let it hide/show itself out from under the open panel.
      if (document.body.style.overflow === 'hidden') {
        header.classList.remove('is-hidden');
        ticking = false;
        return;
      }

      // Transparent → solid transition (homepage only)
      if (isTransparent) {
        if (current > 60) {
          header.classList.add('is-scrolled');
          header.classList.remove('is-transparent');
        } else {
          header.classList.remove('is-scrolled');
          header.classList.add('is-transparent');
        }
      }

      // Smart hide/show on scroll direction
      if (current <= 0) {
        header.classList.remove('is-hidden');
      } else if (current > lastScroll && current > 120) {
        // Scrolling down — hide
        header.classList.add('is-hidden');
      } else if (current < lastScroll) {
        // Scrolling up — show immediately
        header.classList.remove('is-hidden');
      }

      lastScroll = current;
      ticking    = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });

    update();
  }

  // ── Mobile menu ─────────────────────────────────────────────
  function initMobileMenu() {
    var toggle = document.querySelector('.header__mobile-toggle');
    var menu   = document.querySelector('.mobile-menu');
    var overlay= document.querySelector('.mobile-menu-overlay');
    var close  = document.querySelector('.mobile-menu-close');
    if (!toggle || !menu) return;

    function open() {
      menu.classList.add('is-open');
      menu.setAttribute('aria-hidden', 'false');
      toggle.classList.add('is-active');
      toggle.setAttribute('aria-expanded', 'true');
      if (overlay) overlay.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
    }
    function closeMenu() {
      menu.classList.remove('is-open');
      menu.setAttribute('aria-hidden', 'true');
      toggle.classList.remove('is-active');
      toggle.setAttribute('aria-expanded', 'false');
      if (overlay) overlay.classList.remove('is-visible');
      document.body.style.overflow = '';
    }
    function toggleMenu() {
      if (menu.classList.contains('is-open')) { closeMenu(); } else { open(); }
    }

    toggle.addEventListener('click', toggleMenu);
    if (close) close.addEventListener('click', closeMenu);
    if (overlay) overlay.addEventListener('click', closeMenu);
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && menu.classList.contains('is-open')) closeMenu();
    });

    // Accordion: expand/collapse a top-level item's submenu
    var expandBtns = menu.querySelectorAll('.mobile-menu-expand');
    expandBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var group = btn.closest('.mobile-menu-group');
        if (!group) return;
        var isOpen = group.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });
  }

  // ── Search overlay ──────────────────────────────────────────
  function initSearch() {
    var btns    = document.querySelectorAll('[data-action="open-search"]');
    var overlay = document.getElementById('search-overlay');
    var closBtn = overlay && overlay.querySelector('.search-overlay__close');
    var backdrop= overlay && overlay.querySelector('.search-overlay__backdrop');
    if (!overlay) return;

    function open() {
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var input = overlay.querySelector('.search-overlay__input');
      if (input) setTimeout(function() { input.focus(); }, 50);
    }
    function close() {
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    btns.forEach(function(b) { b.addEventListener('click', open); });
    if (closBtn) closBtn.addEventListener('click', close);
    if (backdrop) backdrop.addEventListener('click', close);
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') close();
    });
  }

  // ── Cart drawer ─────────────────────────────────────────────
  function initCartDrawer() {
    // Delegated on document so listeners survive the drawer being re-rendered
    document.addEventListener('click', function(e) {
      // Open
      if (e.target.closest('[data-action="open-cart"]')) {
        openCartDrawer();
        return;
      }

      // Close (overlay or close button)
      if (e.target.closest('.cart-drawer__overlay') || e.target.closest('.cart-drawer__close')) {
        closeCartDrawer();
        return;
      }

      // Quantity +/-
      var qtyBtn = e.target.closest('.cart-drawer .qty-btn');
      if (qtyBtn) {
        var span = qtyBtn.parentNode.querySelector('span');
        var qty  = parseInt(span ? span.textContent : '1', 10);
        if (qtyBtn.dataset.action === 'decrease') qty = Math.max(0, qty - 1);
        if (qtyBtn.dataset.action === 'increase') qty += 1;
        changeCartLine(qtyBtn.dataset.line, qty);
        return;
      }

      // Remove line
      var removeBtn = e.target.closest('.cart-drawer .cart-item__remove');
      if (removeBtn) {
        changeCartLine(removeBtn.dataset.line, 0);
        return;
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key !== 'Escape') return;
      var drawer = document.getElementById('cart-drawer');
      if (drawer && drawer.getAttribute('aria-hidden') === 'false') closeCartDrawer();
    });
  }

  function changeCartLine(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: quantity })
    })
    .then(function(r) { return r.json(); })
    .then(function() { return refreshCartDrawer(); })
    .then(function() { return updateCartCount(); })
    .catch(function(e) { console.error('Cart update error:', e); });
  }

  function closeCartDrawer() {
    var drawer = document.getElementById('cart-drawer');
    if (drawer) drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  // ── Add to cart ─────────────────────────────────────────────
  function initATC() {
    var form = document.querySelector('.product-form');
    if (!form) return;

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var btn = form.querySelector('.btn--atc');
      var variantInput = form.querySelector('[name="id"]');
      if (!variantInput) return;

      btn.textContent = 'Adding…';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantInput.value, quantity: getQty() })
      })
      .then(function(r) {
        return r.json().then(function(data) {
          if (!r.ok) throw new Error(data.description || data.message || 'Add to cart failed');
          return data;
        });
      })
      .then(function() {
        btn.textContent = 'Added!';
        setTimeout(function() {
          btn.textContent = 'Add to Bag';
          btn.disabled = false;
        }, 1500);
        return refreshCartDrawer();
      })
      .then(function() {
        updateCartCount();
        openCartDrawer();
      })
      .catch(function(err) {
        console.error('Cart add error:', err);
        btn.textContent = 'Add to Bag';
        btn.disabled = false;
      });
    });

    function getQty() {
      var qtyEl = document.querySelector('.product-atc__qty-value');
      return qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
    }

    // Qty controls
    document.querySelectorAll('.product-atc__qty-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var display = document.querySelector('.product-atc__qty-value');
        var qty = parseInt(display.textContent, 10);
        if (btn.dataset.action === 'decrease') qty = Math.max(1, qty - 1);
        if (btn.dataset.action === 'increase') qty += 1;
        display.textContent = qty;
      });
    });
  }

  function updateCartCount() {
    return fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var counts = document.querySelectorAll('.header__cart-count');
        counts.forEach(function(el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      })
      .catch(function(e) { console.error('Cart count error:', e); });
  }

  // Re-render the cart drawer from the server (Section Rendering API)
  function refreshCartDrawer() {
    var wasOpen = false;
    var existing = document.getElementById('cart-drawer');
    if (existing) wasOpen = existing.getAttribute('aria-hidden') === 'false';

    return fetch('/?sections=cart-drawer')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var html = data['cart-drawer'];
        if (!html) return;

        var holder = document.createElement('div');
        holder.innerHTML = html;
        var fresh = holder.querySelector('#cart-drawer');
        if (!fresh) return;

        var current = document.getElementById('cart-drawer');
        if (current) {
          current.replaceWith(fresh);
        } else {
          document.body.appendChild(fresh);
        }
        if (wasOpen) fresh.setAttribute('aria-hidden', 'false');
      })
      .catch(function(e) { console.error('Cart drawer refresh error:', e); });
  }

  function openCartDrawer() {
    var drawer = document.getElementById('cart-drawer');
    if (drawer) {
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
  }

  // ── Product gallery thumbnails ───────────────────────────────
  function initProductGallery() {
    var rail  = document.querySelector('.product-gallery__rail');
    var items = document.querySelectorAll('.product-gallery__item');
    if (!items.length) return;

    var thumbs = rail ? rail.querySelectorAll('.product-gallery__thumb') : [];
    var headerOffset = 104;

    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        var target = document.getElementById('pgi-' + thumb.dataset.index);
        if (!target) return;
        var y = target.getBoundingClientRect().top + window.pageYOffset - headerOffset;
        window.scrollTo({ top: y, behavior: 'smooth' });
      });
    });

    if (thumbs.length && 'IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting) return;
          var idx = entry.target.dataset.index;
          thumbs.forEach(function(t) {
            t.classList.toggle('is-active', t.dataset.index === idx);
          });
        });
      }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
      items.forEach(function(it) { obs.observe(it); });
    }

    // Mobile horizontal swipe carousel — dot indicators
    var stack = document.querySelector('.product-gallery__stack');
    var dots  = document.querySelectorAll('.product-gallery__dot');
    if (stack && dots.length) {
      dots.forEach(function(dot) {
        dot.addEventListener('click', function() {
          var target = document.getElementById('pgi-' + dot.dataset.index);
          if (!target || !stack.scrollTo) return;
          stack.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
        });
      });

      var scrollTimer;
      stack.addEventListener('scroll', function() {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function() {
          var stackRect = stack.getBoundingClientRect();
          var center = stackRect.left + stackRect.width / 2;
          var closest = null, closestDist = Infinity;
          items.forEach(function(item) {
            var r = item.getBoundingClientRect();
            var dist = Math.abs((r.left + r.width / 2) - center);
            if (dist < closestDist) { closestDist = dist; closest = item; }
          });
          if (closest) {
            var idx = closest.dataset.index;
            dots.forEach(function(d) { d.classList.toggle('is-active', d.dataset.index === idx); });
          }
        }, 100);
      }, { passive: true });
    }
  }

  // ── Product image zoom hint + click-to-enlarge lightbox ───────
  function initImageZoom() {
    var items = document.querySelectorAll('.product-gallery__item');
    if (!items.length) return;

    var magnifierIcon = '<svg viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
      '<circle cx="11" cy="11" r="7"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line>' +
      '<line x1="11" y1="8" x2="11" y2="14"></line><line x1="8" y1="11" x2="14" y2="11"></line></svg>';

    items.forEach(function(item) {
      var img = item.querySelector('.product-gallery__img');
      if (!img) return;
      item.classList.add('has-zoom');

      var hint = document.createElement('div');
      hint.className = 'zoom-hint';
      hint.innerHTML = magnifierIcon;
      item.appendChild(hint);

      item.addEventListener('click', function() {
        openZoomLightbox(item.dataset.index);
      });
    });
  }

  function openZoomLightbox(index) {
    var lightbox = document.getElementById('zoom-lightbox');
    if (!lightbox) return;
    showZoomSlide(index);
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeZoomLightbox() {
    var lightbox = document.getElementById('zoom-lightbox');
    if (!lightbox) return;
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function showZoomSlide(index) {
    var lightbox = document.getElementById('zoom-lightbox');
    if (!lightbox) return;
    var slides = lightbox.querySelectorAll('.zoom-lightbox__slide');
    slides.forEach(function(slide) {
      slide.classList.toggle('is-active', slide.dataset.index === String(index));
    });
  }

  function initZoomLightbox() {
    var lightbox = document.getElementById('zoom-lightbox');
    if (!lightbox) return;
    var slides = lightbox.querySelectorAll('.zoom-lightbox__slide');
    var total = slides.length;

    lightbox.querySelectorAll('[data-zoom-close]').forEach(function(el) {
      el.addEventListener('click', closeZoomLightbox);
    });

    var prevBtn = lightbox.querySelector('[data-zoom-prev]');
    var nextBtn = lightbox.querySelector('[data-zoom-next]');
    function currentIndex() {
      var active = lightbox.querySelector('.zoom-lightbox__slide.is-active');
      return active ? parseInt(active.dataset.index, 10) : 0;
    }
    if (prevBtn) prevBtn.addEventListener('click', function() {
      showZoomSlide((currentIndex() - 1 + total) % total);
    });
    if (nextBtn) nextBtn.addEventListener('click', function() {
      showZoomSlide((currentIndex() + 1) % total);
    });

    document.addEventListener('keydown', function(e) {
      if (lightbox.getAttribute('aria-hidden') === 'true') return;
      if (e.key === 'Escape') closeZoomLightbox();
      if (e.key === 'ArrowRight' && nextBtn) nextBtn.click();
      if (e.key === 'ArrowLeft' && prevBtn) prevBtn.click();
    });
  }

  // ── Product accordion (Description / Care / Shipping) ────────
  function initProductAccordion() {
    var headers = document.querySelectorAll('.product-accordion__header');
    headers.forEach(function(header) {
      header.addEventListener('click', function() {
        var item = header.closest('.product-accordion__item');
        if (!item) return;
        var isNowClosed = item.classList.toggle('is-closed');
        header.setAttribute('aria-expanded', isNowClosed ? 'false' : 'true');
        var toggle = header.querySelector('.product-accordion__toggle');
        if (toggle) toggle.textContent = isNowClosed ? '+' : '−';
      });
    });
  }

  // ── Product variant selector ─────────────────────────────────
  function initVariants() {
    var optionBtns = document.querySelectorAll('.option-btn, .option-swatch');
    if (!optionBtns.length) return;

    optionBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var group = btn.closest('.option-buttons, .option-swatches');
        if (group) {
          group.querySelectorAll('.option-btn, .option-swatch').forEach(function(b) {
            b.classList.remove('is-active');
          });
        }
        btn.classList.add('is-active');

        // Update hidden variant input
        updateSelectedVariant();

        // Update label
        var optionEl = btn.closest('.product-option');
        if (optionEl) {
          var selected = optionEl.querySelector('.product-option__selected');
          if (selected) selected.textContent = btn.dataset.value || btn.textContent.trim();
        }
      });
    });
  }

  function updateSelectedVariant() {
    var variantInput = document.querySelector('.product-form [name="id"]');
    if (!variantInput) return;

    var selectedValues = [];
    document.querySelectorAll('.product-option').forEach(function(opt) {
      var active = opt.querySelector('.option-btn.is-active, .option-swatch.is-active');
      if (active) selectedValues.push(active.dataset.value || active.textContent.trim());
    });

    var variantData = window.__variantData__;
    if (!variantData) return;

    var match = variantData.find(function(v) {
      return v.options.every(function(o, i) { return o === selectedValues[i]; });
    });

    if (match) {
      variantInput.value = match.id;
      // Update price
      var priceEl = document.querySelector('.product-info__price-current');
      if (priceEl) {
        priceEl.textContent = formatMoney(match.price);
      }
      // Availability
      var atcBtn = document.querySelector('.btn--atc');
      if (atcBtn) {
        if (match.available) {
          atcBtn.disabled = false;
          atcBtn.textContent = 'Add to Bag';
        } else {
          atcBtn.disabled = true;
          atcBtn.textContent = 'Sold Out';
        }
      }
    }
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // ── Filter toggle ─────────────────────────────────────────────
  function initFilters() {
    var headers = document.querySelectorAll('.filter-group__header');
    headers.forEach(function(h) {
      h.addEventListener('click', function() {
        h.closest('.filter-group').classList.toggle('is-closed');
      });
    });

    // Mobile filter toggle
    var filterToggle = document.querySelector('[data-action="toggle-filters"]');
    var filterPanel  = document.querySelector('.collection-filters');
    if (filterToggle && filterPanel) {
      filterToggle.addEventListener('click', function() {
        filterPanel.classList.toggle('is-open');
      });
    }
  }

  // ── Scroll animations ─────────────────────────────────────────
  function initAnimations() {
    if (!document.body.classList.contains('animations-on')) return;
    var els = document.querySelectorAll('.animate-up');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function(el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    els.forEach(function(el) { io.observe(el); });
  }


  // ── Cart page (quantity buttons submit the updates[] form) ───
  function initCartPage() {
    var form = document.getElementById('CartForm');
    if (!form) return;
    var lines = form.querySelector('.cart-lines');

    function submitUpdate() {
      if (lines) lines.classList.add('is-updating');
      // No submitter → the "checkout" button's name is not sent, so this is a plain cart update.
      if (form.requestSubmit) { form.requestSubmit(); } else { form.submit(); }
    }

    form.addEventListener('click', function(e) {
      var btn = e.target.closest('.cart-qty__btn');
      if (!btn) return;
      var input = btn.parentNode.querySelector('.cart-qty__input');
      if (!input) return;
      var qty = parseInt(input.value, 10) || 0;
      if (btn.dataset.action === 'decrease') qty = Math.max(0, qty - 1);
      if (btn.dataset.action === 'increase') qty += 1;
      input.value = qty;
      submitUpdate();
    });

    form.querySelectorAll('.cart-qty__input').forEach(function(input) {
      input.addEventListener('change', submitUpdate);
      // Enter inside the quantity field must update the bag, not trigger the checkout button.
      input.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') { e.preventDefault(); submitUpdate(); }
      });
    });
  }

  // ── Init ──────────────────────────────────────────────────────

  // ── Mega menu — full-width, JS-positioned ───────────────────
  function initMegaMenu() {
    var items  = document.querySelectorAll('.has-megamenu');
    var header = document.querySelector('.site-header');
    if (!items.length || !header) return;

    var activeMenu  = null;
    var closeTimer  = null;
    var CLOSE_DELAY = 120;

    function getHeaderBottom() {
      return header.getBoundingClientRect().bottom;
    }

    function openMenu(menu) {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      if (activeMenu && activeMenu !== menu) {
        activeMenu.classList.remove('is-open');
      }
      menu.style.top = getHeaderBottom() + 'px';
      menu.classList.add('is-open');
      activeMenu = menu;
    }

    function scheduleClose() {
      closeTimer = setTimeout(function () {
        if (activeMenu) {
          activeMenu.classList.remove('is-open');
          activeMenu = null;
        }
      }, CLOSE_DELAY);
    }

    items.forEach(function (item) {
      var menu = item.querySelector('.megamenu');
      if (!menu) return;

      item.addEventListener('mouseenter', function () { openMenu(menu); });
      item.addEventListener('mouseleave', scheduleClose);

      menu.addEventListener('mouseenter', function () {
        if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      });
      menu.addEventListener('mouseleave', scheduleClose);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && activeMenu) {
        activeMenu.classList.remove('is-open');
        activeMenu = null;
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    initHeader();
    // initMegaMenu(); // removed — CSS hover handles mega menu
    initMobileMenu();
    initSearch();
    initCartDrawer();
    initCartPage();
    initATC();
    initProductGallery();
    initImageZoom();
    initZoomLightbox();
    initProductAccordion();
    initVariants();
    initFilters();
    initAnimations();
  });

})();
